module.exports = __webpack_public_path__ + "static/universal_solvent-aa95aefb37bdd2d168c1fe1a6a1c0739.jpeg";